import { render, staticRenderFns } from "./BaseSelectRegion.vue?vue&type=template&id=f97a80e8&scoped=true"
import script from "./BaseSelectRegion.vue?vue&type=script&lang=js"
export * from "./BaseSelectRegion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f97a80e8",
  null
  
)

export default component.exports